import redirectInterceptor from "@/interceptors/redirect_interceptor";

export class SensorIssuesService {
  constructor(baseUrl, sensorIssueMapper) {
    this.baseUrl = baseUrl;
    this.sensorIssueMapper = sensorIssueMapper;
  }

  async getSensorIssuesVessel(accessToken, vesselName, startDate, endDate) {
    try {
      const response = await redirectInterceptor.get(
        `${this.baseUrl}/sensor_issues/vessel/${vesselName}`,
        {
          headers: {
            "Authorization": `${accessToken}`,
          },
          params: {
            startDate,
            endDate
          }
        }
      );
      return response.data.map(this.sensorIssueMapper);
    } catch (error) {
      throw error;
    }
  }
}
